import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import featureContent from "../data/featureContent"; // Import the data dictionary
import { nonNavButtonStyle } from "../help/Utils";

const FeatureTemplate = () => {
  const { slug } = useParams(); // Access the dynamic route parameter
  const feature = featureContent.find((item) => item.slug === slug); // Find content by slug

  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
      mirror: false,
      offset: 120,
      easing: "ease-in-out",
    });
  }, []);

  // Animation styles
  const floatyStyle = `
    @keyframes floaty1 {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }
    .animate-floaty1 {
      animation: floaty1 3s ease-in-out infinite;
    }
  `;

  if (!feature) {
    return <div>Feature Under Process.</div>; // Handle invalid slugs
  }

  return (
    <div>
      <style>{floatyStyle}</style> {/* Add animation styles */}
      {/* Hero Section */}
      <section
        className="flex flex-col md:flex-row justify-between md:mt-10 w-[85%] mx-auto"
        data-aos="fade-up"
      >
        <div className="md:w-1/2 md:mt-16 mt-10">
          <h1 className="mb-5 md:text-6xl text-center md:text-start  font-bold">
            {feature.title}
          </h1>
          <h2 className="mb-5 text-2xl text-center md:text-start md:text-3xl">
            {feature.description}
          </h2>
          <p className="mb-10 text-gray-700 leading-[30px]">
            {feature.details}
          </p>
          <div className="flex md:justify-start justify-center mb-10 md:mb-0">
            <Link to="/signup" style={nonNavButtonStyle}>
              <button className="btn-primary">{feature.buttonLabel}</button>
            </Link>
          </div>
        </div>
        <div className="md:w-1/3 h-[500px] rounded-s-[50px]">
          <img
            src={feature.image}
            className="animate-floaty1"
            alt={feature.title}
          />
        </div>
      </section>
      {/* Dynamic Sections */}
      {feature.sections.map((section, index) => {
        const layoutClass = section.textOnLeft
          ? "flex-row"
          : "flex-row-reverse";
        const borderRadiusClass = section.textOnLeft
          ? "rounded-l-[50px]"
          : "rounded-r-[50px]";
        const marginClass = section.textOnLeft ? "ml-[7.5%]" : "mr-[7.5%]";

        return (
          <section
            key={index}
            className={`flex flex-col  justify-between mt-20 mb-10 md:${layoutClass}`}
            data-aos="fade-up"
          >
            {/* Text Content */}
            <div
              className={`md:w-1/2 px-5 flex flex-col justify-center md:${marginClass}`}
            >
              <h2 className="text-3xl font-semibold mb-4">{section.title}</h2>
              <h3 className="text-xl text-secondaryColor mb-4">
                {section.subtitle}
              </h3>
              <p className="text-gray-700 leading-7">{section.content}</p>
              <div className="mt-6 mb-10">
                <Link to="/signup" style={nonNavButtonStyle}>
                  <button className="btn-primary">
                    {section.buttonLabel || "Learn More"}
                  </button>
                </Link>
              </div>
            </div>

            {/* Image Section */}
            <div
              className={`md:w-1/3 h-[500px] bg-primaryColor overflow-hidden ${borderRadiusClass}`}
            >
              <img
                src={section.image}
                className="w-full h-full object-cover animate-floaty1"
                alt={section.title}
              />
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default FeatureTemplate;
